var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBooklogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000006767"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.12658 6.18052H8.37673C8.66897 6.14476 8.88931 5.88543 8.88931 5.57725C8.88931 5.26907 8.66897 5.00973 8.37673 4.97397H3.12658C2.90478 4.94682 2.6878 5.05551 2.56872 5.25339C2.44965 5.45128 2.44965 5.70321 2.56872 5.9011C2.6878 6.09899 2.90478 6.20767 3.12658 6.18052Z",
    fill: "#FFAF64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.12658 12.7468H6.87221C7.09402 12.774 7.311 12.6653 7.43007 12.4674C7.54914 12.2695 7.54914 12.0176 7.43007 11.8197C7.311 11.6218 7.09402 11.5131 6.87221 11.5403H3.12658C2.90478 11.5131 2.6878 11.6218 2.56872 11.8197C2.44965 12.0176 2.44965 12.2695 2.56872 12.4674C2.6878 12.6653 2.90478 12.774 3.12658 12.7468Z",
    fill: "#FFAF64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.87342 9.46367H3.12658C2.90478 9.49082 2.6878 9.38213 2.56872 9.18424C2.44965 8.98636 2.44965 8.73443 2.56872 8.53654C2.6878 8.33865 2.90478 8.22997 3.12658 8.25711H9.87342C10.1656 8.29288 10.386 8.55221 10.386 8.86039C10.386 9.16857 10.1656 9.42791 9.87342 9.46367Z",
    fill: "#FFAF64"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.2387 16.9H3.75347C1.67922 16.8955 -4.5014e-06 15.1329 0 12.9602V3.93157C0.00431051 1.7621 1.68227 0.00451505 3.75347 0H9.2387C11.313 -4.715e-06 12.9957 1.7589 13 3.93157V12.9602C13 14.0051 12.6037 15.0072 11.8983 15.7461C11.193 16.4849 10.2363 16.9 9.2387 16.9ZM3.75346 1.30505C2.37038 1.30956 1.25023 2.48285 1.24593 3.93157V12.9602C1.24592 14.4121 2.36733 15.5904 3.75346 15.5949H9.2387C10.6279 15.5949 11.7541 14.4153 11.7541 12.9602V3.93157C11.7497 2.47966 10.6248 1.30504 9.2387 1.30505H3.75346Z",
    fill: "#FFAF64"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooklogo);
export default __webpack_public_path__ + "static/media/booklogo.10c31e834125a61332775e828a117476.svg";
export { ForwardRef as ReactComponent };